import { AppDrawer, Heading, IconButton } from '@components'
import { useService } from 'solid-services'
import { useChannels } from '@state'
import { Menu } from 'lucide-solid'
import { createEffect, createSignal } from 'solid-js'
import { css } from 'styled-system/css'
import { Box } from 'styled-system/jsx'
import Channels from './Channels'
import { useLocation } from '@solidjs/router'
import ChannelSetups from './Setups'

export default function Header() {
	const { activeName } = useService(useChannels)()
	const [isOpen, setIsOpen] = createSignal(false)
	const location = useLocation()

	createEffect(() => {
		location.pathname
		setIsOpen(false)
	})

	return (
		<Box
			display={{
				base: 'none',
				lgDown: 'flex',
			}}
			justifyContent="space-between"
			alignItems="center"
			class={css({
				boxShadow: 'none',
				borderRadius: 'l2',
				p: 2,
				border: 'solid 1px var(--colors-gray-4)',
			})}
		>
			<Heading
				variant="heading"
				size="xs"
				textTransform="capitalize"
			>
				{activeName()}
			</Heading>

			<AppDrawer
				open={isOpen()}
				onOpenChange={({ open }) => setIsOpen(open)}
				title={activeName()}
				trigger={
					<IconButton
						size="xs"
						variant="subtle"
					>
						<Menu />
					</IconButton>
				}
			>
				<Channels />
				<ChannelSetups />
			</AppDrawer>
		</Box>
	)
}
